var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ContextMenuPlanning',{ref:"menu",attrs:{"model":_vm.mapItems,"baseZIndex":999}})
}
var staticRenderFns = []

export { render, staticRenderFns }